import { useAsync } from '@flowwai-frontend/shared/common-components'

import { LoginWithUsernameRequestType } from '../../services/types'

import { useLoginWithUsernameService } from '../services/useLoginWithUsernameService'

const useLoginWithUsernameAPI = () => {
   const loginService = useLoginWithUsernameService()

   const {
      mutateAsync: loginWithUsernameAPI,
      apiStatus: loginWithUsernameAPIStatus,
      error: loginWithUsernameAPIError
   } = useAsync<unknown, Error, LoginWithUsernameRequestType>(
      loginService.loginWithUsername
   )

   return {
      loginWithUsernameAPI,
      loginWithUsernameAPIStatus,
      loginWithUsernameAPIError
   }
}

export { useLoginWithUsernameAPI }
